/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online aspect ratio calculator. Find the simplified ratio (e.g. 16:9) of any width and height, and resize keeping the same ratio. Works in your browser.`)
};

const es_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de relación de aspecto en línea. Encuentra la relación simplificada (por ejemplo, 16:9) de cualquier ancho y alto, y redimensiona manteniendo la misma relación. Funciona en tu navegador.`)
};

const de_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Seitenverhältnis-Rechner. Findet das vereinfachte Verhältnis (z. B. 16:9) einer beliebigen Breite und Höhe und ändert die Größe unter Beibehaltung desselben Verhältnisses. Funktioniert direkt in deinem Browser.`)
};

const nl_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online beeldverhouding calculator. Vind de vereenvoudigde verhouding (bijvoorbeeld 16:9) van elke breedte en hoogte, en pas de grootte aan met dezelfde verhouding. Werkt in je browser.`)
};

const fr_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de rapport d'aspect en ligne gratuit. Trouvez le rapport simplifié (par exemple 16:9) de n'importe quelle largeur et hauteur, et redimensionnez en gardant le même rapport. Fonctionne dans votre navigateur.`)
};

const it_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito online del rapporto di aspetto. Trova il rapporto semplificato (ad es. 16:9) di qualsiasi larghezza e altezza e ridimensiona mantenendo lo stesso rapporto. Funziona nel tuo browser.`)
};

const pt_br2_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de taxa de aspecto online gratuita. Encontre a taxa simplificada (por exemplo, 16:9) de qualquer largura e altura, e redimensione mantendo a mesma taxa. Funciona no seu navegador.`)
};

const pt_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de proporção de aspecto online gratuita. Encontre a proporção simplificada (por exemplo, 16:9) de qualquer largura e altura, e redimensione mantendo a mesma proporção. Funciona no seu navegador.`)
};

const ja_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインアスペクト比計算機。任意の幅と高さの簡略化された比率（例：16:9）を見つけ、同じ比率を保ったままリサイズできます。ブラウザで動作します。`)
};

const zh_ar_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线宽高比计算器。找出任意宽度和高度的化简比例(例如16:9),并在保持相同比例的情况下调整大小。可在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_meta_description", locale)
	if (locale === "en") return en_ar_meta_description(inputs)
	if (locale === "es") return es_ar_meta_description(inputs)
	if (locale === "de") return de_ar_meta_description(inputs)
	if (locale === "nl") return nl_ar_meta_description(inputs)
	if (locale === "fr") return fr_ar_meta_description(inputs)
	if (locale === "it") return it_ar_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ar_meta_description(inputs)
	if (locale === "pt") return pt_ar_meta_description(inputs)
	if (locale === "ja") return ja_ar_meta_description(inputs)
	return zh_ar_meta_description(inputs)
};